// Imports custom
import { Typography } from '@mui/material'
import { TransactionTable } from './TransactionTable'

export const PaymentReversal = ({ useFetchInit }) => {
    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <TransactionTable useFetchInit={useFetchInit}/>
        </>
    )
}